import { getDirection } from './abilities';
import { BLUE_PIECES } from './constants';

const allPossibleDirections = [
  { x: -1, y: -1 },
  { x: 0, y: -1 },
  { x: 1, y: -1 },
  { x: -1, y: 0 },
  { x: -1, y: 1 },
  { x: 0, y: 1 },
  { x: 1, y: 0 },
  { x: 1, y: 1 }
];

export function determineBounceBack(origin, destinationTile, map, mapWidth) {
  const direction = getDirection(origin, destinationTile);

  const tileX = destinationTile.x + direction[0] * -1;
  const tileY = destinationTile.y + direction[1] * -1;
  let tile = getTileIndexInMapOrMapData(tileX, tileY, map, mapWidth);
  const bouncedBackToSameSpot = origin.x === tileX && origin.y === tileY;
  // look for backup?
  if (tile && tile.index !== -1 && tile.index !== 0 && !bouncedBackToSameSpot) {
    const possibilities = allPossibleDirections.filter(
      spot => !(spot.x === direction[0] * -1 && spot.y === direction[1] * -1)
    );
    //sort by distance from origin
    possibilities.sort((a, b) => {
      const aDist = distanceBetweenTwoPoints(origin, a);
      const bDist = distanceBetweenTwoPoints(origin, b);
      return aDist - bDist;
    });
    possibilities.find(possibility => {
      const backupTileX = destinationTile.x + possibility.x;
      const backupTileY = destinationTile.y + possibility.y;
      const backupTile = getTileIndexInMapOrMapData(
        backupTileX,
        backupTileY,
        map,
        mapWidth
      );
      if (backupTile && backupTile.index === -1) {
        tile = backupTile;
        return true;
      }
      return false;
    });
  }
  return tile;
}

export function getTileIndexInMapOrMapData(x, y, map, mapWidth) {
  if (map && typeof map.getTileAt === 'function') {
    return map.getTileAt(x, y, true, 'logic_layer');
  } else {
    return { index: map[x + y * mapWidth], x, y };
  }
}

export const distanceBetweenTwoPoints = (one, two) => {
  const a = one.x - two.x;
  const b = one.y - two.y;
  return Math.sqrt(a * a + b * b);
};

export const getRectangleOfPlayerTiles = data => {
  let rectX = 999;
  let rectY = 999;
  let right = -1;
  let bottom = -1;

  data.mapData.lvlData.logic.forEach((row, y) => {
    row.forEach((tile, x) => {
      if (BLUE_PIECES.includes(tile)) {
        rectX = Math.min(rectX, x);
        rectY = Math.min(rectY, y);
        right = Math.max(x, right);
        bottom = Math.max(y, bottom);
      }
    });
  });
  const rectangle = {
    x: rectX,
    y: rectY,
    width: right - rectX + 1,
    height: bottom - rectY + 1
  };

  const targetArea = [];

  for (let i = rectangle.y; i < rectangle.y + rectangle.height; i++) {
    targetArea[i - rectangle.y] = [];
    for (let j = rectangle.x; j < rectangle.x + rectangle.width; j++) {
      targetArea[i - rectangle.y][j - rectangle.x] =
        data.mapData.lvlData.logic[i][j];
    }
  }
  return { rectangle, targetArea };
};
